import { render, staticRenderFns } from "./FAQContent.vue?vue&type=template&id=3651291b&scoped=true&v-slot%3Acontent=true&"
import script from "./FAQContent.vue?vue&type=script&lang=ts&"
export * from "./FAQContent.vue?vue&type=script&lang=ts&"
import style0 from "./FAQContent.vue?vue&type=style&index=0&id=3651291b&scoped=true&lang=css&"
import style1 from "./FAQContent.vue?vue&type=style&index=1&id=3651291b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3651291b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
